import React from "react";
import Images from "../../Assets/Images";
function Card({ card,data, isSelected, onSelect }) {
  console.log({ card: data });
  return (
    <div
      className={`card  mt-3 ${isSelected ? "selected" : ""}`}
      onClick={onSelect}
    >
      <div className="card-goal d-flex ">
        <img src={data.image} alt="Image 1" />
        <div className="card-body p-3">
          <h2 className="card-title">{data.name}</h2>
          <p className="card-text">{data.description}</p>
        </div>
      </div>
    </div>
  );
}

export default Card;
